import { FormBuilder, FormControl, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { ObjetMaquette } from '@app/features/editeur/models/objet-maquette.model';
import { descripteursObjetMaquetteValidators } from '@app/shared/base-form/validators-config';
import { CreerObjetMaquetteRequest, TypeObjetMaquette } from '@pcscol/odf-api-v1-angular';
import { AbstractDescripteursForm } from '../../../../../shared/form-models/abstract-descripteurs-form';

interface Perimetre {
    code: string;
    libelle: string;
}

export class CreerObjetMaquetteForm extends AbstractDescripteursForm {
    constructor(protected formGroup: FormGroup, protected readonly typeObjetMaquette: TypeObjetMaquette) {
        super(formGroup, typeObjetMaquette);
    }

    private _parent?: ObjetMaquette;
    public set parent(parent: ObjetMaquette) {
        this._parent = parent;
        this.formGroup.controls.mutualise.setValue(this._parent?.mutualise);
        if (this._parent.mutualise) {
            this.formGroup.controls.mutualise.disable();
        }
    }

    public static createForm(fb: FormBuilder | NonNullableFormBuilder, typeObjetMaquette: TypeObjetMaquette) {
        const form = fb.group({
            code: fb.control(null, {
                validators: descripteursObjetMaquetteValidators.code
            }),
            typeObjetMaquette: fb.control<TypeObjetMaquette | null>(null, {
                validators: descripteursObjetMaquetteValidators.typeObjetMaquette
            }),
            mutualise: fb.control(false, { validators: descripteursObjetMaquetteValidators.mutualise }),
            perimetres: fb.control<Perimetre[]>([])
        });

        return new CreerObjetMaquetteForm(form, typeObjetMaquette);
    }

    public get asPartialRequest(): Partial<CreerObjetMaquetteRequest> {
        return {
            code: this.formGroup.controls.code.value,
            mutualise: this.computeMutualiseForRequest(),
            typeObjetMaquette: this.formGroup.controls.typeObjetMaquette.value
        };
    }

    public get perimetresControl(): FormControl<Perimetre[]> {
        return this.formGroup.controls.perimetres as FormControl<Perimetre[]>;
    }

    private computeMutualiseForRequest(): boolean {
        if (this.isFormation) {
            return false;
        } else if (this.parent?.mutualise === true) {
            return true;
        } else {
            return this.formGroup.controls.mutualise.value;
        }
    }
}
